import axios from 'axios';
import store from '../app/store';

class AxiosConfig {
  constructor(method, path) {
    this.method = method;
    this.path = path;
    this.profile = store.getState().login.profile;
    this.baseUrl = `${import.meta.env.VITE_API_URL}/api`;
    this.response = null;
  }

  call(data) {
    const response = axios({
      method: this.method,
      url: `${this.baseUrl}${this.path}`,
      headers: {
        UserID: this.profile?._id,
        User: this.profile?.email,
      },
      withCredentials: true,
      data: data || null,
    });
    this.response = response;
    return this;
  }

  async exit(exec) {
    if (exec && this.response) {
      this.response = await this.response.then(exec(await this.response));
    }
    return this;
  }

  async getResponseData() {
    this.response = await this.response;
    return this.response.data;
  }

  async getResponseStatus() {
    this.response = await this.response;
    return this.response.status;
  }

  async getFullResponse() {
    this.response = await this.response;
    return this.response;
  }

  googleGetResponse(user) {
    const response = axios({
      method: this.method,
      url: `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user?.access_token}`,
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
        Accept: 'application/json',
      },
    });
    this.response = response;
    return this.response;
  }

  async login(data, user) {
    const response = axios({
      method: this.method,
      url: `${this.baseUrl}${this.path}`,
      headers: { UserID: this.profile?._id, User: this.profile?.email },
      Authorization: `Bearer ${user?.access_token}`,
      Accept: 'application/json',
      withCredentials: true,
      data: data || null,
    });
    this.response = await response;
    return this.response;
  }

  static instances = new Map();

  static create(method, path) {
    const id = `${method}_${path}`;
    if (!this.instances.has(id)) {
      this.instances.set(id, new AxiosConfig(method, path));
    }
    return this.instances.get(id);
  }
}

export default AxiosConfig;
